// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__1TrvX","tag":"Tags_tag__2pvIC","closeIcon":"Tags_closeIcon__27So6","isOwner":"Tags_isOwner__WkBHW","addTagInput":"Tags_addTagInput__2BVMK"};